import { useTranslation } from 'react-i18next';
import { useWallets } from '../contexts/wallets-context';

type UseConnectWalletButtonStatesProps = {
  isLinkedWallets?: boolean;
  replaceConnectWithLink?: boolean;
}

export const useConnectWalletButtonStates = ({
  isLinkedWallets = false,
  replaceConnectWithLink = false,
}: UseConnectWalletButtonStatesProps = {}) => {
  const {
    isConnecting,
    isSigningPending,
    isConnected,
    isChainIdMatched,
    mainAddress,
    connectWallet,
    disconnect,
    switchChain,
  } = useWallets();
  const { t } = useTranslation();

  if (isConnecting) {
    return {
      buttonText: t('walletButtons.connecting'),
      buttonClass: 'yellow-button',
      buttonAction: () => {},
    };
  }

  if (isSigningPending) {
    return {
      buttonText: t('walletButtons.awaiting_signature'),
      buttonClass: 'yellow-button',
      buttonAction: () => {},
    };
  }

  if (!isConnected && mainAddress && isLinkedWallets) {
    return {
      buttonText: t('walletButtons.link_another_wallet'),
      buttonClass: 'yellow-button',
      buttonAction: () => connectWallet.mutateAsync({}),
    };
  }

  if (!isConnected) {
    return {
      buttonText: replaceConnectWithLink ? t('walletButtons.link_wallet') : t('walletButtons.connect_wallet'),
      buttonClass: 'yellow-button',
      buttonAction: () => connectWallet.mutateAsync({}),
    };
  }

  return isChainIdMatched
    ? {
      buttonText: t('walletButtons.disconnect_wallet'),
      buttonClass: 'red-button',
      buttonAction: disconnect,
    }
    : {
      buttonText: t('walletButtons.switch_network'),
      buttonClass: 'red-button',
      buttonAction: () => switchChain(),
    };
};
